import React, { useEffect, useState } from "react";
import StorefrontTitle from "../shared/storefront-title.component";
import CommonPaymentSuccessIcon from "../../assets/img/CommonPaymentSuccess.svg";
import Settings from "../../services/settings.service";
import DownloadApps from "../shared/DownloadApps";
import Storage from "../../services/storage.service";
import Translation from "../../services/translation.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import FirebaseAnalytics from "../../services/analytics.service";

const BillPaymentSuccess = () => {
  const [loader, setLoader] = useState(false);
  const prefix = "scr_3.3.3";
  const appDownloadInfo = Translation.keys[prefix + "_app_download_info"];

  const redirectToHome = () => {
    setLoader(true);
    const firebase_event_params = {
      event_category: 'bills',
      event_screen: 'bill_success',
      interaction_type: 'click',
      event_label: 'go_to_homepage'
    }
    FirebaseAnalytics.commonFunction(firebase_event_params);
    Storage.clear("session");
    localStorage.clear();
    window.location.href = Settings.site_link;
  }
  const handleStoreClick = (storeName) => {
    const firebase_event_params = {
      event_category: 'bills',
      event_screen: 'bill_success',
      interaction_type: 'click',
      event_label: storeName,
    };
    FirebaseAnalytics.commonFunction(firebase_event_params);
  };

  useEffect(() => {
    FirebaseAnalytics.generic_event(15);
    const firePayInfo = Storage.get("firePayInfo", true);
    const data = (() => {
      try { return JSON.parse(Storage.get("SelectedPaymentMethodTemp", true) || "null"); } catch { return null; }
    })();
    const firebase_event_params = {
      event_category: 'bills',
      event_screen: 'bill_success',
      interaction_type: 'view',
      event_label: 'pay',
      bill_number: data?.InvoiceNo ||  0,
      bill_amount: JSON.parse(firePayInfo)?.amt || 0,
      payment_amount: data?.TotalDueAmount ||  0,
      payment_method: `${Storage.get("selected_payment_method", true)}` || ''
    }
    FirebaseAnalytics.commonFunction(firebase_event_params);
    if(firePayInfo) {
      const firePayObj = JSON.parse(firePayInfo);
      if(firePayObj?.type === "bill_payment") {
        try {
          const findVat = () => {
            let vat_percentage = JSON.parse(Storage.get("business", true))[
              "vat_percentage"
            ] || 0;
            return vat_percentage;
          }
          let firebase_param = {
            payment_status: 1,
            amount: firePayObj?.amt || 0,
            currency: Settings?.currency || "SR",
            tax: findVat() || 0,
            item_category: "bill"
          }
          FirebaseAnalytics.pay_bill(firebase_param)
        } catch(error) {
          // Do Nothing
        }
      }
    }
  }, [])

  const firebase_event_properties = {
    event_screen: 'bill_success',
    interaction_type: "click"
  }
  
  return (
    <>
      {loader ? <SpinnerTimeLoader /> :
        <div className="stm-topup-info-container bill-payment-success-failed">
          <div className="success-img">
            <img src={CommonPaymentSuccessIcon} alt="" />
          </div>
          <StorefrontTitle
            title={Translation.keys["stm_bill_payment_success_heading"]}
            desc={Translation.keys["stm_bill_payment_success_desc"]}
          />
          <div className="topup-field-wrapper">
            <div className="topup-btn-section">
              <button
                className="storefront-button"
                type="button"
                onClick={() => { redirectToHome() }}
              >
                {Translation.keys["stm_go_to_homepage"]}
              </button>
            </div>
          </div>
          <DownloadApps
            info={appDownloadInfo}
            classes={"download-apps"}
            google_play_link={Settings.google_play_link}
            app_store_link={Settings.app_store_link}
            huawei_store_link={Settings.huawei_store_link}
            onStoreClick={handleStoreClick}
            firebase_event_properties={firebase_event_properties}
          />
        </div>
      }
    </>
  );
};

export default BillPaymentSuccess;
